import { baseURL } from "./config";
import { Request } from "./request";

export const getURL = (url) => {
  return `${baseURL}${url}`;
};

// captcha
const get_captcha = (
  font_color = "ffffff",
  color = "1c2a52",
  base_color = "1c2a52"
) => {
  return Request.get(getURL(`/api/v1/accounts/captcha/`), {
    font_color,
    color,
    base_color,
  });
};

// login
const post_login = (username, password, captcha, captcha_uuid) => {
  return Request.post(getURL(`/api/pa/accounts/login/`), {
    username,
    password,
    captcha,
    captcha_uuid,
  });
};

// dashboard
const get_dashboard = () => {
  return Request.get(getURL(`/api/pa/content/dashboard/`));
};

// sites
const get_sites = (has_products = null) => {
  return Request.get(getURL(`/api/pa/content/sites/`), {
    has_products,
  });
};

// sellers
const get_sellers = (product_id = null, site_id = null) => {
  return Request.get(getURL(`/api/pa/sellers/`), {
    product_id,
    site_id,
  });
};

// citeis
const get_cities = (
  available_product_id = null,
  available_seller_id = null,
  available_site_id = null
) => {
  return Request.get(getURL(`/api/pa/locations/cities/`), {
    available_product_id,
    available_seller_id,
    available_site_id,
  });
};

// products
const get_products = (
  page = 1,
  limit = 10,
  is_active = null,
  search = null,
  brand_id = null,
  category_id = null
) => {
  return Request.get(getURL(`/api/pa/products/`), {
    page,
    limit,
    is_active,
    search,
    brand_id,
    category_id,
  });
};

const get_product = (product_id) => {
  return Request.get(getURL(`/api/pa/products/${product_id}/`));
};

const get_brands = () => {
  return Request.get(getURL(`/api/pa/products/brands/`));
};

const get_categories = () => {
  return Request.get(getURL(`/api/pa/products/categories/`));
};

// seller products
const get_seller_products = (
  product_id = null,
  site_id = null,
  paginate = null,
  page = null,
  limit = null,
  search = null,
  brand_id = null,
  category_id = null,
  is_active = null,
  city_id = null,
  seller_id = null
) => {
  return Request.get(getURL(`/api/pa/sellers/products/`), {
    product_id,
    site_id,
    paginate,
    page,
    limit,
    search,
    brand_id,
    category_id,
    is_active,
    city_id,
    seller_id,
  });
};

const get_export_seller_products = (
  product_id = null,
  site_id = null,
  search = null,
  brand_id = null,
  category_id = null,
  is_active = null,
  city_id = null,
  seller_id = null
) => {
  return Request.rawGet(getURL(`/api/pa/sellers/products/export/`), {
    product_id,
    site_id,
    search,
    brand_id,
    category_id,
    is_active,
    city_id,
    seller_id,
  });
};

const put_import_seller_products = (data) => {
  return Request.formPut(getURL(`/api/pa/sellers/products/import/`), data);
};

const post_seller_product = (data) => {
  return Request.post(getURL(`/api/pa/sellers/products/`), data);
};

const put_seller_product = (seller_product_id, data) => {
  return Request.put(
    getURL(`/api/pa/sellers/products/${seller_product_id}/`),
    data
  );
};

const get_product_city_stocks = ({
  product_id = null,
  city_id = null,
  stock_type = null,
  start_date = null,
  end_date = null,
}) => {
  return Request.get(getURL(`/api/pa/products/product-city-stocks`), {
    product_id,
    city_id,
    stock_type,
    start_date,
    end_date,
  });
};

const upload_product_city_stocks = (data) => {
  return Request.formPost(getURL(`/api/pa/products/product-city-stocks/`), data);
}

const get_service_center_stocks = ({ service_center_id, product_id, origin }) => {
  return Request.get(getURL(`/api/pa/service-center/service-center-stock/`), {
    product_id,
    service_center_id,
    origin,
  });
}

export const API = {
  get: {
    captcha: get_captcha,
    dashboard: get_dashboard,
    sites: get_sites,
    sellers: get_sellers,
    cities: get_cities,
    products: get_products,
    product: get_product,
    brands: get_brands,
    categories: get_categories,
    seller_products: get_seller_products,
    export_seller_products: get_export_seller_products,
    product_city_stocks: get_product_city_stocks,
    service_center_stocks: get_service_center_stocks
  },
  post: {
    login: post_login,
    seller_product: post_seller_product,
    upload_product_city_stocks,
  },
  put: {
    seller_product: put_seller_product,
    import_seller_products: put_import_seller_products,
  },
};
